import { Moon, Sun } from '@phosphor-icons/react';
import { useTheme } from '@/providers/ThemeProvider';
import { cn } from '@/lib/utils/cn';

/** Light/dark switch. Shows the icon for the mode you'll switch *to*. */
export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      role="switch"
      aria-checked={isDark}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
      className={cn(
        'grid place-items-center w-9 h-9 rounded-md border border-line-2 bg-bg-2 text-muted',
        'hover:text-brand hover:border-brand transition-colors',
        className,
      )}
    >
      {isDark ? (
        <Sun size={17} weight="bold" aria-hidden />
      ) : (
        <Moon size={17} weight="bold" aria-hidden />
      )}
    </button>
  );
}
